import {IDeviceInfoParameters, DeviceType, IGeoInfoParameters, IUserInfoParameters} from '@sparkware/uc-sdk-core';
import {IServiceFactoryExtended} from '../service-factory-extended.interface';
import Device from "../../../sdk/src/utils/device/device";

export function getCasinofiedDeviceInfo(services: IServiceFactoryExtended): IDeviceInfoParameters {
    return {
        deviceType: getCasinofiedDeviceType(services),
        isHybrid: Device.hybrid.inCasino,
        OS: services.device.os.name,
        isNative: false,
        browserType: services.device.os.name
    };
}

export function getCasinofiedCommonUserInfo(services: IServiceFactoryExtended): IUserInfoParameters {
    return {
        userMode: 'anonymous',
        regulationTypeID: services.regulation.getRegulationCode(),
        isFTD: services.user.userData?.isFTD || false,
        isVIP: services.user.isVip,
        isPromotionPermitted: services.user.userData?.IsPromotionPermitted || false,
        RMS: services.user.playerRMSStatus,
        userFirstName: services.user.userData?.firstName,
        userLastName: services.user.userData?.lastName
    }
}
export async function getCasinofiedGeoInfoParams(services: IServiceFactoryExtended): Promise<IGeoInfoParameters> {
    const geoLocationInfo = await services.sdk.getGeoLocationInfo();
    return {
        country: services.sdk.getCountryIso3()?.toUpperCase(),
        timeZoneUTCOffset: services.time.getTimezoneOffset().toString(),
        loginIp: services.user.loginIP,
        ISP: geoLocationInfo?.isp,
        proxyType: geoLocationInfo?.proxyType
    }
}

export function getCasinofiedCommonAppContextParams(services: IServiceFactoryExtended) {
    return {
        productPackageFromID: services.sdk.getProductPackageId(),
        brandID: services.sdk.getBrandID(),
        subBrandID: services.sdk.getSubBrandID(),
        languageCode: services.language.currentLanguage,
        locale: services.sdk.getSkin().getCulture(),
        currencyCode: services.currency.currencyIso3,
        gaClientID: services.analytics.getGoogleClientID()
    }
}

function getCasinofiedDeviceType(services: IServiceFactoryExtended) {
    if(services.device.isTablet) {
        return DeviceType.Tablet;
    }

    if(services.device.os.isMobileOS) {
        return DeviceType.SmartPhone;
    }

    return DeviceType.PC;
}
